// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPresupuesto_Engorde = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'presupuesto_engorde',
        name: 'presupuesto_engorde',
        component: ViewPresupuesto_Engorde,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
